import go from 'gojs';
import moment from 'moment';
import { getTranslate } from 'react-localize-redux';
import Cookies from 'universal-cookie';
import { getScrollY } from '../../almightyElementWrapper';
import { apiGet, apiPost, getHostApi, hasPermission } from '../../apiWrapper';
import { getType } from '../../browserDetection';
import { isNullOrUndefined, updateObject } from "../../storeFunctions";
import { _updateBottomWindow } from '../bottomWindow/actions';
import { GRAPH_MODE, GRAPH_TYPE, LOAD_TYPE, VISIBILITY_TYPE, _name } from '../common/constants';
import { _handleError, _setCookie, _unique } from '../common/functions';
import { initializeShapes } from '../diagram/templates/shapes';
import { _getExportModel, _resetExportButtons } from '../exports/actions';
import { _allRelationTypesChecked, _applyWarningTypeFilter, _changeRelationTypes, _findRelChilds, getLeftPanelHeight, leftPanelActions } from '../leftPanel/actions';
import { leftPanelInitial } from '../leftPanel/initial';
import { tooltipsActions } from '../tooltips/actions';
import { _getGraphType, _getLayout, _getProfiVersionChecked, _getRelationLabelsChecked, _processProfileData, _toggleProfiVersion, _toggleRelationLabels, topPanelActions } from '../topPanel/actions';
import { _loadVisualization, _resetVisualizations } from '../visualizations/actions';
import { diagram, diagramParamsInitial } from "./initial";
import { _reloadCounts } from './relationCountActions';
import { _createPathReqParams, _createReqParams } from './requests';
import { createLinkTemplateMap } from './templates/link';
import { _showNextLevel, createNodeTemplateMap } from './templates/node';
import { _deleteNode, _deleteRelation, _hasAnyDeletedPart, _setVisibility } from './visiblityActions';

// KEYS
const actions = {
    ROOT_UPDATE: _name + '_ROOT_UPDATE',
    LEGEND_UPDATE: _name + '_LEGEND_UPDATE',
    DOMAINS_UPDATE: _name + '_DOMAINS_UPDATE',
};

// MAP
const actionMap = {
    [`${actions.ROOT_UPDATE}`]: (state, data) => { return updateObject(state, data); },
    [`${actions.LEGEND_UPDATE}`]: (state, data) => updateObject(state, { legendData: updateObject(state.legendData, data) }),
    [`${actions.DOMAINS_UPDATE}`]: (state, data) => updateObject(state, { domains: updateObject(state.domains, data) }),

}

// ACTIONS
const chartActions = {
    initializeDomains: () => async (dispatch, getState) => {
        dispatch({ type: actions.ROOT_UPDATE, data: { domainsInitialized: false } });

        diagram._currentUser = {
            id: getState().userContext.authentication.profile.id,
            name: getState().userContext.authentication.profile.name,
            surname: getState().userContext.authentication.profile.surname
        };

        apiGet(`${getHostApi()}/api/charts/user-profile`, undefined,
            data => _processProfileData(data.data, dispatch, getState().charts),
            undefined,
            () => {
                apiGet(`${getHostApi()}/api/charts/all-warnings`, undefined,
                    data => dispatch({ type: actions.LEGEND_UPDATE, data: { warnings: data.data } }));
                apiGet(`${getHostApi()}/api/charts/relation-types`, undefined,
                    data => dispatch({ type: actions.DOMAINS_UPDATE, data: { relationTypes: data.data } }),
                    undefined,
                    () => apiGet(`${getHostApi()}/api/charts/warning-types`, undefined,
                        data => {
                            dispatch({ type: actions.DOMAINS_UPDATE, data: { warningTypes: data.data } })
                        },
                        undefined,
                        () => apiGet(`${getHostApi()}/api/charts/all-supplementary`, undefined,
                            data => {
                                dispatch({ type: actions.DOMAINS_UPDATE, data: { supplementary: data.data } });
                                dispatch({ type: actions.LEGEND_UPDATE, data: { supplementary: data.data } });
                            },
                            undefined,
                            () => dispatch({ type: actions.ROOT_UPDATE, data: { domainsInitialized: true } })
                        )
                    )
                )
            });
    },
    initializeDiagram: (
        rootIds,
        params,
        showCustomEntityPopupFunc,
        showRelationUnlimitedPopup,
        showCustomRelationPopupFunc,
        showCustomSearchPopupFunc,
        addToClipboardFunc,
        removeFromClipboardFunc,
        showInformationMessagePopupFunc,
        showWarningMessagePopupFunc,
    ) => (dispatch, getState) => _initializeDiagram(
        dispatch,
        getState,
        rootIds,
        params,
        showCustomEntityPopupFunc,
        showRelationUnlimitedPopup,
        showCustomRelationPopupFunc,
        showCustomSearchPopupFunc,
        addToClipboardFunc,
        removeFromClipboardFunc,
        showInformationMessagePopupFunc,
        showWarningMessagePopupFunc,
    ),
    initialize: () => async (dispatch, getState) => {
        dispatch({ type: actions.ROOT_UPDATE, data: { scrolledTo: false, leftPanel: Object.assign({}, getState().charts.leftPanel, { height: getLeftPanelHeight() }) } });
    },
    setDiagramParams: (newParams) => async () => {
        diagram.diagramParams = { ...newParams };
    },
    resetDiagramParams: () => async () => {
        diagram.diagramParams = { ...diagramParamsInitial }
    },
    innerResize: () => async (dispatch, getState) => {
        dispatch({ type: actions.ROOT_UPDATE, data: { sizeChanged: false, leftPanel: Object.assign({}, getState().charts.leftPanel, { height: getLeftPanelHeight() }) } });
        if (diagram.nodeDiagram)
            diagram.nodeDiagram.requestUpdate();
    },
    setScrolled: () => async (dispatch) => dispatch({ type: actions.ROOT_UPDATE, data: { scrolledTo: true } }),
    requestUpdate: () => async () => {
        if (!isNullOrUndefined(diagram.nodeDiagram))
            diagram.nodeDiagram.requestUpdate()
    },
    showNextLevel: (node, expandOnlyId) => async (dispatch, getState) => {
        _showNextLevel(node, dispatch, getState, expandOnlyId);
    },
}

// FUNCTIONS

// INIT
function _initializeDiagram(
    dispatch,
    getState,
    rootIds,
    params,
    showCustomEntityPopupFunc,
    showRelationUnlimitedPopup,
    showCustomRelationPopupFunc,
    showCustomSearchPopupFunc,
    addToClipboardFunc,
    removeFromClipboardFunc,
    showInformationMessagePopupFunc,
    showWarningMessagePopupFunc,
) {
    // PROCESS PARAMS
    diagram._rootIdList = rootIds;
    _processParams(dispatch, getState, params);

    diagram._showCustomEntityPopupFunc = showCustomEntityPopupFunc;
    diagram._showRelationUnlimitedPopup = showRelationUnlimitedPopup;
    diagram._showCustomRelationPopupFunc = showCustomRelationPopupFunc;
    diagram._showCustomSearchPopupFunc = showCustomSearchPopupFunc;
    diagram._addToClipboardFunc = addToClipboardFunc;
    diagram._removeFromClipboardFunc = removeFromClipboardFunc;
    diagram._showInformationMessagePopupFunc = showInformationMessagePopupFunc;
    diagram._showWarningMessagePopupFunc = showWarningMessagePopupFunc;

    // TOP PANEL - LOAD DATA FROM COOKIES
    const ck = new Cookies();
    var type = ck.get("TypeController");
    if (type !== '' && !isNullOrUndefined(type) && Object.values(GRAPH_TYPE).indexOf(type) !== -1) {
        dispatch({ type: topPanelActions.TOP_PANEL.TOGGLE, data: { graphType: type } });
    }

    const labels = ck.get('RelationCaptionDisplay');
    if (labels !== '' && !isNullOrUndefined(labels) && (labels === 'true' || labels === true || labels === 'false' || labels === false)) {
        const val = labels === 'true' || labels === true;
        dispatch({ type: topPanelActions.TOP_PANEL.TOGGLE, data: { linkLabels: val } });
    }

    const pro = ck.get('ProfiVersionNiDisplay');
    if (pro !== '' && !isNullOrUndefined(pro) && (pro !== 'true' || pro !== true || pro !== 'false' || pro !== false)) {
        const val = pro === 'true' || pro === true;
        dispatch({ type: topPanelActions.TOP_PANEL.TOGGLE, data: { isProfi: val } });
    } else {
        apiGet(`${getHostApi()}/api/charts/negative-version-profi-display`,
            undefined,
            data => {
                dispatch({ type: topPanelActions.TOP_PANEL.TOGGLE, data: { isProfi: data.data } });
                _setCookie("ProfiVersionNiDisplay", data.data);
            });
    }

    // LEFT PANEL
    dispatch({
        type: leftPanelActions.LEFT_PANEL.TOGGLE, data: {
            level: diagram.diagramParams.level,
            dateFrom: diagram.diagramParams.dateFrom,
            dateTo: diagram.diagramParams.dateTo,
            history: diagram.diagramParams.history,
            lockedAll: leftPanelInitial.lockedAll,
            linkDirection: diagram.diagramParams.direction,
            shareChecked: diagram.diagramParams.shareChecked,
            shareValue: diagram.diagramParams.sharePct
        }
    });

    _resetExportButtons(dispatch);
    _resetVisualizations(dispatch);

    var warType = getState().charts.domains.warningTypes;
    for (var i = 0; i < warType.length; i++)
        diagram.diagramParams.wt = diagram.diagramParams.wt.concat(_findRelChilds(warType[i]));
    dispatch({ type: leftPanelActions.LEFT_PANEL.TOGGLE, data: { wt: diagram.diagramParams.wt, warTypesAllChecked: true, warTypesAllPartial: false } });

    if (diagram.diagramParams.rt.length === 0) {
        var relType = getState().charts.domains.relationTypes;
        relType = relType.filter(rt => rt.value !== 'NR08' && rt.value !== 'NR0H' && rt.value !== 'NR0G');
        for (let i = 0; i < relType.length; i++)
            diagram.diagramParams.rt = diagram.diagramParams.rt.concat(_findRelChilds(relType[i]));
    }
    const allChecked = _allRelationTypesChecked(getState);
    dispatch({ type: leftPanelActions.LEFT_PANEL.TOGGLE, data: { rt: diagram.diagramParams.rt, relTypesAllChecked: allChecked.checked, relTypesAllPartial: allChecked.partial } });

    // BOTTOM PANEL
    let bottom = { ...getState().charts.bottomWindow };
    if (bottom.negInfo.isShowed || bottom.timeline.isShowed || bottom.subjects.isShowed) {
        document.getElementById('diagramPlane').style.height = '65%';
        document.getElementById('bottomContainer').style.height = '35%';
    }

    // DIAGRAM
    initializeShapes();

    diagram.nodeDiagram = new go.Diagram();
    diagram.nodeDiagram.initialContentAlignment = go.Spot.Center;
    diagram.nodeDiagram.contentAlignment = go.Spot.Center;
    diagram.nodeDiagram.initialAutoScale = go.Diagram.Uniform;
    diagram.nodeDiagram.hasHorizontalScrollbar = true;
    diagram.nodeDiagram.hasVerticalScrollbar = true;
    const graphType = getState().charts.topPanel.graphType;
    diagram.nodeDiagram.layout = _getLayout(graphType);

    diagram.nodeDiagram.model = go.GraphObject.make(go.GraphLinksModel,
        {
            nodeKeyProperty: "EntityID",
            linkToKeyProperty: "ChildID",
            linkFromKeyProperty: "ParentID"
        });

    diagram.nodeDiagram.addDiagramListener("BackgroundSingleClicked", function (e) { e.diagram.toolManager.contextMenuTool.hideContextMenu(); });
    diagram.nodeDiagram.addDiagramListener("LayoutCompleted", function () {
        if (diagram._noGraphZoom !== true) {
            setTimeout(() => { _fitDiagram(30) }, 1000);
        }
        diagram._noGraphZoom = undefined;

        if (diagram._recalculateRelationsCounts === true) {
            setTimeout(() => { _reloadCounts() }, 500);
        }
        diagram._recalculateRelationsCounts = false;
        _updateBottomWindow(dispatch);
    });

    diagram.nodeDiagram.toolManager.doMouseWheel = function () {
        go.ToolManager.prototype.doMouseWheel.call(diagram.nodeDiagram.toolManager);
        _closeMainContextMenu();
    }

    diagram.nodeDiagram.toolManager.doMouseMove = function () {
        go.ToolManager.prototype.doMouseMove.call(diagram.nodeDiagram.toolManager);
        var e = diagram.nodeDiagram.lastInput;

        if (e.buttons === 1) {
            _closeMainContextMenu();
        }

        // implement the magnifying glass functionality, to have the Overview show part of the Diagram where the mouse is
        var magnifierDiv = document.querySelector("#magnifierDivWindow");
        if (magnifierDiv.style.display === "none" || diagram.nodeMagnifier === undefined || diagram.nodeMagnifier == null) {
            return;
        }

        var pos = document.querySelector('#diagramPlane')
        var osize = diagram.nodeMagnifier.viewportBounds.size;
        diagram.nodeMagnifier.position = new go.Point(e.documentPoint.x - (osize.width / 2), e.documentPoint.y - (osize.height / 2));

        var left = (e.event.clientX - (osize.width / 2));
        if (left < pos.offsetLeft)
            magnifierDiv.style.left = pos.offsetLeft + 'px';
        else
            if (left > pos.offsetWidth - pos.offsetLeft - (osize.width / 2))
                magnifierDiv.style.left = pos.offsetWidth - pos.offsetLeft - (osize.width / 2) + 'px';
            else
                magnifierDiv.style.left = left + 'px';

        var top = (e.event.clientY + getScrollY() - (osize.height / 2));
        if (top < pos.offsetTop)
            magnifierDiv.style.top = pos.offsetTop + 'px';
        else
            if (top > pos.offsetHeight - 35)
                magnifierDiv.style.top = pos.offsetHeight - 35 + 'px';
            else
                magnifierDiv.style.top = top + 'px';
    }

    diagram.nodeDiagram.addLayerBefore(go.GraphObject.make(go.Layer, { name: 'merge' }), diagram.nodeDiagram.findLayer(""));
    diagram.nodeDiagram.addDiagramListener("ChangedSelection", function (e) {
        if (window._noConflictGoCustomSelection !== undefined) { return; }
        if (e.diagram.selection.count === 0) { return; }

        var allSelected = [];
        var it = e.diagram.selection.iterator;
        while (it.next()) { allSelected.push(it.value.data.EntityID); }

        document.querySelectorAll('#tableSubjectList tbody tr').forEach(function (s) { s.classList.remove('selected'); });
        allSelected.forEach(function (s) {
            const sub = document.querySelectorAll(`#tableSubjectList tbody tr[eid="${s}"]`);
            if (sub !== undefined && sub !== null) {
                sub.forEach(s => s.classList.add('selected'));
            }
        });
    });

    diagram.nodeDiagram.commandHandler.doKeyDown = function () {
        const e = diagram.nodeDiagram.lastInput;
        if (e.key === 'Del' && hasPermission(null, "RCDeleteSubjects") === true) {
            diagram.nodeDiagram.startTransaction('hideSelectedEntities');
            diagram.nodeDiagram.selection.each((part) => {
                if (part instanceof go.Node) {
                    _deleteNode(part);
                }
                else if (part instanceof go.Link) {
                    _deleteRelation(part);
                }
            });
            diagram.nodeDiagram.commitTransaction('hideSelectedEntities');
            diagram.nodeDiagram.clearSelection();
            _resetExportButtons(dispatch);
            _updateTotalNodeCount(dispatch);
            _updateBottomWindow(dispatch);
        } else {
            go.CommandHandler.prototype.doKeyDown.call(this);
        }
    };

    const browser = getType();
    diagram._marginCorrection = browser === 'Safari' || browser === 'Edge';
    diagram.nodeDiagram.nodeTemplateMap = createNodeTemplateMap(dispatch, getState);
    diagram.nodeDiagram.linkTemplateMap = createLinkTemplateMap(dispatch);
    diagram.nodeDiagram.scaleComputation = _scaleComputation;

    if (!isNullOrUndefined(params) && !isNullOrUndefined(params.visualizationId)) {
        _loadVisualization(dispatch, getState, parseInt(params.visualizationId));
    } else {
        _load(dispatch, getState, LOAD_TYPE.initial);
    }

    return diagram.nodeDiagram;
}

function _processParams(dispatch, getState, params) {
    diagram._initParams = params;

    if (!isNullOrUndefined(params)) {
        if (!isNullOrUndefined(params.hist))
            diagram.diagramParams.history = params.hist === true || params.hist === "true";
        if (!isNullOrUndefined(params.from) && moment(params.from).isValid())
            diagram.diagramParams.dateFrom = moment(params.from).toDate();
        if (!isNullOrUndefined(params.to) && moment(params.to).isValid())
            diagram.diagramParams.dateTo = moment(params.to).toDate();
        if (!isNullOrUndefined(params.level))
            diagram.diagramParams.level = parseInt(params.level);
        if (!isNullOrUndefined(params.rt)) {
            const relGroups = params.rt.split(/,/);
            const allTypes = getState().charts.domains.relationTypes;
            let rt = [];
            for (let i = 0; i < allTypes.length; i++)
                for (let j = 0; j < relGroups.length; j++)
                    if (allTypes[i].value.indexOf(relGroups[j]) === 0) {
                        rt.push(allTypes[i].value);
                        let childs = _findRelChilds(allTypes[i])
                        rt = _unique(rt.concat(childs));
                    }
            diagram._initParams.rtFull = rt;
            diagram.diagramParams.rt = rt;
        }
    }

    if (params && (params.mode === 'path' || params.mode === GRAPH_MODE.path))
        diagram._mode = GRAPH_MODE.path;
    else if (params && (params.mode === 'merge' || params.mode === GRAPH_MODE.merge))
        diagram._mode = GRAPH_MODE.merge;
    else
        diagram._mode = GRAPH_MODE.default;

    dispatch({ type: actions.ROOT_UPDATE, data: { mode: diagram._mode } });
}

function _closeMainContextMenu() {
    if (diagram.nodeDiagram.toolManager.contextMenuTool.currentContextMenu != null &&
        diagram.nodeDiagram.toolManager.contextMenuTool.currentContextMenu.mainElement != null) {
        diagram.nodeDiagram.toolManager.contextMenuTool.currentContextMenu.mainElement.style.display = 'none';
    }
}

// LOAD CONDITIONS

function _checkLoadConditions(getState, loadFunc) {
    _checkDeletedSubjects(getState, loadFunc);
}

function _checkDeletedSubjects(getState, loadFunc) {
    if (_hasAnyDeletedPart()) {
        diagram._showWarningMessagePopupFunc(getTranslate(getState().localize)('Charts.DeletedSubjects.FullReloadWarning'), loadFunc);
    } else {
        loadFunc();
    }
}

// LOAD

function _load(dispatch, getState, type) {
    diagram.selectedNodes = [];
    dispatch({ type: actions.ROOT_UPDATE, data: { loading: true } });
    dispatch({ type: tooltipsActions.CONTEXT_MENU.HIDE });
    _resetExportButtons(dispatch);

    var rtUsed = [];
    var wtUsed = [];

    const { method, reqParams } = _getMethodAndParams(getState, type);

    apiPost(`${getHostApi()}/api/charts/${method}`, undefined, reqParams,
        data => {
            _processLoadData(dispatch, getState, data, rtUsed, wtUsed, type === LOAD_TYPE.reload);

            _toggleRelationLabels(dispatch, _getRelationLabelsChecked())
            _toggleProfiVersion(dispatch, _getProfiVersionChecked());
            _changeRelationTypes();
            _applyWarningTypeFilter();

            switch (type) {
                case LOAD_TYPE.initial:
                case LOAD_TYPE.common:
                default:
                    {
                        diagram._noGraphZoom = undefined;
                        diagram._recalculateRelationsCounts = true;
                        diagram.nodeDiagram.layoutDiagram(true);
                        if (type === LOAD_TYPE.initial) {
                            _centerChart(500);
                        }
                        break;
                    }
                case LOAD_TYPE.reload:
                    {
                        _fitDiagram(30);
                        _reloadCounts(dispatch, getState);
                        _updateBottomWindow(dispatch);
                        break;
                    }
            }
        }, err => {
            _handleError(`/api/charts/${method} error`, err, getState);
        }, _ => {
            dispatch({ type: leftPanelActions.LEFT_PANEL.TOGGLE, data: { historyChanged: false, filterChanged: false, directionChanged: false, shareChanged: false, relationTypesChanged: false, rtUsed, wtUsed } });
            dispatch({ type: actions.ROOT_UPDATE, data: { loading: false } });
        });
}

function _getMethodAndParams(getState, type) {
    let method;
    let reqParams;

    switch (type) {
        case LOAD_TYPE.initial:
        case LOAD_TYPE.common:
        default:
            {
                if (diagram._mode === GRAPH_MODE.path) {
                    method = 'path-data';
                    reqParams = _createPathReqParams();
                }
                else {
                    method = 'tree-data';
                    reqParams = _createReqParams(getState, diagram._rootIdList, type === LOAD_TYPE.initial);
                }
                break;
            }
        case LOAD_TYPE.reload:
            {
                method = 'reload-data';
                const state = getState().charts;
                reqParams = _getExportModel(state, false);
                break;
            }
    }

    return { method, reqParams };
}

function _processLoadData(dispatch, getState, data, rtUsed, wtUsed, isReload = false) {
    let event = '';
    const { Relations, RelationsOriented, Nodes, Timeouted, LimitReached } = data.data;

    if (diagram._mode === GRAPH_MODE.path) {
        if (Relations.length === 0 && RelationsOriented.length === 0) event += 'NotFound';
        if (Timeouted) event += 'Timeouted';
        if (LimitReached) event += 'LimitReached';
        if (event) event = 'Charts.SearchPath' + event;
    } else if (LimitReached) {
        event = 'Charts.LimitReached';
    }

    if (event) {
        diagram._showInformationMessagePopupFunc(getTranslate(getState().localize)(event));
    }

    diagram._relationsOriented = RelationsOriented;
    diagram._relations = Relations;
    diagram._nodes = Nodes;

    const graphType = _getGraphType();
    const visibilityType = VISIBILITY_TYPE.visible;
    _processRelations(diagram._relations, graphType, visibilityType, isReload);
    _processRelations(diagram._relationsOriented, graphType, visibilityType, isReload);
    diagram._nodes.forEach(function (value) {
        value.Level = graphType === GRAPH_TYPE.oriented ? value.OrientedLevel : value.OriginalLevel;
    });

    // merge
    if (diagram._mode === GRAPH_MODE.merge && diagram._rootIdList.length > 1) {
        diagram._nodes.push({
            EntityID: -1,
            WarningShortcuts: [],
            category: 'merge',
            Level: 0,
            OrientedLevel: 0,
            OriginalLevel: 0,
            Type: "Company",
            EntityType: "MergedRoot",
            Name: "MergedRoot"
        });

        diagram._rootIdList.forEach(value => {
            diagram._relations.push({ ParentID: -1, ChildID: value, Type: 1, category: 'merge', RelationsData: [] });
            diagram._relationsOriented.push({ ParentID: -1, ChildID: value, Type: 1, category: 'merge', RelationsData: [] });
        });
    }

    // post-process subjects
    const rootCountryCode = [];
    let isRootForeign = false;
    let isRootSlovak = false;
    let isRootCzech = false;

    diagram._nodes.forEach(subject => {
        if (diagram._mode === GRAPH_MODE.merge && diagram._rootIdList.length > 1 && subject.EntityID !== -1) {
            subject.Level = subject.OriginalLevel = subject.Level + 1;
        }

        if (_isRootElement(subject.EntityID)) {
            rootCountryCode.push(subject.CountryCode || "00");
        }
    });

    if (rootCountryCode.every(rcc => rcc === rootCountryCode[0])) {
        switch (rootCountryCode[0]) {
            case "67":
                isRootSlovak = true;
                break;
            case "19":
                isRootCzech = true;
                break;
            default:
                isRootForeign = true;
        }
    } else {
        isRootForeign = true;
    }

    // root is not CZ or SK
    diagram._nodes.forEach(function (value) {
        value.GraphType = graphType;
        value.showFlag = (value.CountryCode !== null && value.CountryCode !== '' && value.CountryCode !== undefined && value.CountryCode !== '00') &&
            (isRootForeign || (isRootCzech && value.CountryCode !== rootCountryCode[0]) || (isRootSlovak && value.CountryCode !== rootCountryCode[0]));
        value.isRootForeign = isRootForeign;
        value.isRootSlovak = isRootSlovak;
        value.isRootCzech = isRootCzech;
        value.actualRelationsCount = 0;
        if (isReload) {
            const n = diagram.nodeDiagram.findNodeForKey(value.EntityID);
            if (n && n.part) {
                value.Location = go.Point.stringify(n.part.location);
            }
            value.Visibility = n && n.data && !isNullOrUndefined(n.data.Visibility) ? n.data.Visibility : visibilityType;
        } else {
            value.Visibility = visibilityType;
        }
    });

    diagram.nodeDiagram.model.nodeDataArray = diagram._nodes;
    diagram.nodeDiagram.model.nodeDataArray.forEach((node) => {
        node.WarningShortcuts.forEach((w) => {
            if (wtUsed.indexOf(w.GroupID) === -1)
                wtUsed.push(w.GroupID);
        });
    });
    diagram.nodeDiagram.model.linkDataArray = (graphType === GRAPH_TYPE.oriented ? diagram._relationsOriented : diagram._relations);
    diagram.nodeDiagram.model.linkDataArray.forEach(function (r) {
        r.RelationsData.forEach(function (rd) {
            if (rtUsed.indexOf(rd.TypeCD) === -1)
                rtUsed.push(rd.TypeCD);
        })
    });
    diagram.nodeDiagram.model.isReadOnly = true;

    _updateTotalNodeCount(dispatch);
}

function _processRelations(relations, graphType, defaultVisibility, isReload) {
    relations.forEach(rel => {
        rel.GraphType = graphType;
        if (isReload) {
            _updateRelationVisibility(rel, defaultVisibility);
        } else {
            rel.Visibility = defaultVisibility;
        }
        _removeRelationDefaultStartDate(rel);
    });
};

function _updateRelationVisibility(relation, defaultVisibility) {
    const link = diagram.nodeDiagram.links.filter(f =>
        f.data.RelationsData.some(rel =>
            rel.RelationID === relation.RelationsData[0].RelationID
        )
    ).first();

    relation.Visibility = link && link.data && !isNullOrUndefined(link.data.Visibility) ? link.data.Visibility : defaultVisibility;
};

function _removeRelationDefaultStartDate(relation) {
    if (relation.RelationsData != null && relation.RelationsData instanceof Array) {
        for (let relLen = 0; relLen < relation.RelationsData.length; ++relLen) {
            if (relation.RelationsData[relLen].StartDate === "1900-01-01T00:00:00")
                relation.RelationsData[relLen].StartDate = null;
        }
    }
}

function _updateTotalNodeCount(dispatch) {
    const nodeCount = diagram.nodeDiagram.model.nodeDataArray.filter(function (el) { return diagram.nodeDiagram.findPartForKey(el.EntityID).isVisible(); }).length;
    dispatch({ type: actions.ROOT_UPDATE, data: { nodeCount: nodeCount } });
}

function _centerChart(timeout) {
    const _fn = () => {
        if (diagram.nodeDiagram === null || diagram.nodeDiagram === undefined) {
            setTimeout(_fn, timeout ? timeout : 100);
            return;
        }

        let i = 0;
        diagram.nodeDiagram.findTreeRoots().each(function (n) {
            if (n instanceof go.Node) {
                if (i === 0) {
                    diagram.nodeDiagram.centerRect(n.actualBounds);
                    i += 1;
                }
            }
        });
    };
    setTimeout(_fn, timeout ? timeout : 100);
}

function _scaleComputation(d, newScale) {
    var isExact = d.rc_exactFitToZoom !== undefined && d.rc_exactFitToZoom != null && d.rc_exactFitToZoom;
    var old = Math.round(d.scale * 100);
    var result = Math.round(newScale * 100);

    if (old === 5 && result === 5 && newScale > d.scale)
        result = result + 5;

    var isZoomIn = result > old;

    // if is not 5% step round it to nearest 5% step
    if ((result) % 5 !== 0)
        result = Math.floor(Math.floor((result) / 5) * 5);

    // if is too small zoom rounding can produce results which will lead to no zoom
    if (!isZoomIn && old === result)
        result = result - 5; //zoom out correction

    if (isZoomIn && old === result)
        result = result + 5; //zoom in correction

    // write zoom to element

    if (isExact) {
        result = Math.floor(newScale * 100);
        d.rc_exactFitToZoom = undefined;
    } else {
        if (document.getElementById('zoomTextBox')) {
            var currentValue = document.getElementById('zoomTextBox').value.replace("%", "");
            if (diagram.userScaleInput) {
                diagram.userScaleInput = false;
                result = parseInt(currentValue);
            }
        }
    }

    if (isNaN(result)) {
        result = 5;
    }

    // 5% scale is minimum
    if (result < 5)
        result = 5;

    if (isExact && d.rc_zoomLimit !== undefined && d.rc_zoomLimit != null && result < d.rc_zoomLimit)
        result = d.rc_zoomLimit;

    // 100% scale is maximum
    if (result > 100)
        result = 100
    if (document.getElementById('zoomTextBox')) {
        document.getElementById('zoomTextBox').value = Math.round(result) + "%";
    }

    return result / 100;
}

// OTHER
function _raiseDataChanged(partData, property, newValue) {
    const oldValue = partData[property];
    if (newValue !== oldValue) {
        partData[property] = newValue;
        diagram.nodeDiagram.model.raiseDataChanged(partData, property, oldValue, partData[property]);
    }
}

function _fitDiagram(zoomLimit) {
    diagram.nodeDiagram.startTransaction("fitDiagram");
    diagram.nodeDiagram.rc_exactFitToZoom = true;
    diagram.nodeDiagram.rc_zoomLimit = zoomLimit;
    diagram.nodeDiagram.zoomToFit();
    diagram.nodeDiagram.commitTransaction("fitDiagram");
}

function _isRootElement(entityId) {
    return diagram._rootIdList.filter(rootId => rootId === entityId).length === 1;
}

function _getRootElement(dgrm) {
    var rootIds = diagram._rootIdList.slice(0);
    var result = rootIds.map(r => {
        let nodes = dgrm.model.nodeDataArray.filter(f => f.EntityID === r);
        return nodes.length > 0 ? nodes[0] : null
    }).filter(g => g !== null);
    return result.length > 0 ? result[0] : null;
}

function _getLockedNodeIds() {
    const lockedNodesIds = [];
    if (diagram._nodes) {
        diagram._nodes.forEach(n => {
            if (n.IsLocked)
                lockedNodesIds.push(n.EntityID);
        });
    }
    return lockedNodesIds;
}

function _insertNewLink(link) {
    const graphType = _getGraphType();

    _mergeNewLink(link, diagram._relations, graphType, graphType !== GRAPH_TYPE.oriented);
    // _mergeNewLink(link, diagram._relationsOriented, graphType, graphType === GRAPH_TYPE.oriented);
}

function _mergeNewLink(link, targetArray, graphType, insertToDiagram) {
    var existingLink = targetArray.filter(e =>
        ((e.ChildID === link.ParentID && e.ParentID === link.ChildID) || (e.ParentID === link.ParentID && e.ChildID === link.ChildID)) &&
        e.Guaranteed === link.Guaranteed &&
        e.RootRelationShortening === link.RootRelationShortening &&
        e.SharePct === link.SharePct &&
        e.State === link.State
    );

    if (existingLink.length === 0) {
        var child = diagram.nodeDiagram.model.nodeDataArray.filter(nd => nd.EntityID === link.ChildID);
        var parent = diagram.nodeDiagram.model.nodeDataArray.filter(nd => nd.EntityID === link.ParentID);

        //Not change for custom relations
        if (link.RelationType !== "NRCU") {
            if (child.length > 0 && parent.length > 0 && child[0].OriginalLevel < parent[0].OriginalLevel) {
                var tmpid = link.ChildID;
                link.ChildID = link.ParentID;
                link.ParentID = tmpid;
                link.Polarity = link.Polarity * -1;
            }
        }

        link.GraphType = graphType;
        link.Visibility = VISIBILITY_TYPE.visible;
        if (insertToDiagram) {
            diagram.nodeDiagram.model.addLinkData(link);
        }
        else {
            targetArray.push(link);
        }
    } else {
        var existingRelations = existingLink[0].RelationsData.map(function (el) { return el.RelationType });
        link.RelationsData.filter(function (l) { return existingRelations.filter(er => er === l.RelationType).length === 0 }).forEach(function (item) { existingLink[0].RelationsData.push(item); });

        const part = diagram.nodeDiagram.links.filter(f =>
            f.data.RelationsData.some(rel =>
                rel.RelationID === existingLink[0].RelationsData[0].RelationID
            )
        ).first();

        if (part && !part.visible) {
            _setVisibility(part, VISIBILITY_TYPE.visible);
        }
    }
}

function _isIsolated(node) {
    if (!node || _isRootElement(node.data.EntityID)) {
        return false;
    }

    const visitedNodes = new Set();

    function hasPathToParent(currentNode) {
        if (_isRootElement(currentNode.data.EntityID)) {
            return true;
        }

        visitedNodes.add(currentNode);
        const currentNodeLevel = currentNode.data.OriginalLevel;
        const connections = currentNode.linksConnected;

        while (connections.next()) {
            const link = connections.value;
            if (link.visible) {
                const otherNode = link.getOtherNode(currentNode);
                if (otherNode.data.OriginalLevel <= currentNodeLevel && !visitedNodes.has(otherNode)) {
                    if (hasPathToParent(otherNode)) {
                        return true;
                    }
                }
            }
        }

        return false;
    }

    return !hasPathToParent(node);
}

export {
    _checkLoadConditions, _fitDiagram, _getLockedNodeIds, _getRootElement, _insertNewLink, _isIsolated, _isRootElement, _load, _processParams, _raiseDataChanged, _removeRelationDefaultStartDate, _updateTotalNodeCount,
    actionMap as diagramActionMap, actions as diagramActions, chartActions as diagramChartActions
};

